import React from 'react';
import { LexdexLogo } from '../LexdexLogo';
import ConversationList from '../ConversationList/ConversationList';
import { MessageSquare, X, Send } from 'lucide-react';
import { useChat } from '../../hooks';
import './ChatWidget.css';

interface ChatWidgetProps {
  chat: ReturnType<typeof useChat>;
}

const ChatWidget: React.FC<ChatWidgetProps> = ({ chat }) => {
  return (
    <>
      {/* Chat FAB Button */}
      <button className={`chat-fab ${chat.isChatOpen ? 'hidden' : ''}`} onClick={chat.toggleChat}>
        <MessageSquare size={24} />
      </button>

      {/* Chat Modal */}
      {chat.isChatOpen && (
        <>
          <div className="chat-backdrop" onClick={chat.toggleChat}></div>
          <div className="chat-modal">
            <div className="chat-modal-header">
              <div className="chat-modal-title">
                <LexdexLogo width={32} height={32} showText={false} />
                <span className="chat-modal-name">Lex</span>
              </div>
              <button onClick={chat.toggleChat} className="close-chat-button">
                <X size={20} />
              </button>
            </div>

            <div className="chat-messages">
              {chat.messages.map((message) => (
                <div key={message.id} className={`message ${message.role}`}>
                  <div className="message-content">{message.content}</div>
                </div>
              ))}
              {chat.isLoading && (
                <div className="message assistant">
                  <div className="message-content">
                    <div className="typing-indicator">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              )}
              <div ref={chat.messagesEndRef} />
            </div>

            <div className="chat-input-container">
              <button
                className={`chats-toggle-button ${chat.isConversationsOpen ? 'active' : ''}`}
                onClick={() => chat.setIsConversationsOpen(!chat.isConversationsOpen)}
                title="Chat History"
              >
                <img src="/message.svg" alt="Chat History" />
              </button>
              <textarea
                className="chat-input"
                value={chat.input}
                onChange={(e) => chat.setInput(e.target.value)}
                onKeyDown={chat.handleKeyPress}
                placeholder="Ask me anything about your cases..."
                rows={1}
              />
              <button
                className="send-button"
                onClick={chat.handleSend}
                disabled={chat.isLoading || !chat.input.trim()}
              >
                <Send size={20} />
              </button>
            </div>

            {chat.isConversationsOpen && (
              <ConversationList
                isOpen={chat.isConversationsOpen}
                onSelectConversation={chat.handleSelectConversation}
                onNewConversation={chat.handleNewConversation}
                onClose={() => chat.setIsConversationsOpen(false)}
              />
            )}
          </div>
        </>
      )}
    </>
  );
};

export default ChatWidget;
